import createIcon from '../../createIcon';

/**
 * @component @name ViewQuilt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNVYxMS41SDkuMzNWNUgyMVpNMTQuNjcgMTlWMTIuNUg5LjMzVjE5SDE0LjY3Wk0xNS42NyAxMi41VjE5SDIxVjEyLjVIMTUuNjdaTTguMzMgMTlWNUgzVjE5SDguMzNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewQuilt = createIcon('ViewQuilt', [
  [
    'path',
    {
      d: 'M21 5V11.5H9.33V5H21ZM14.67 19V12.5H9.33V19H14.67ZM15.67 12.5V19H21V12.5H15.67ZM8.33 19V5H3V19H8.33Z',
      key: '18ncvv',
    },
  ],
]);

export default ViewQuilt;
